// Match the existing role precedence. Multi-role admins and brokerage accounts
// keep their existing views during the photographer-first design review.
export const usesAdminDashboard = (user) => !!user?.roles?.admin && !user.roles.post_production && !user.roles.sales_rep;
export const usesPostProductionDashboard = (user) => !!user?.roles?.post_production;

export const productionMediaTarget = (user, project, search) => {
  if (!usesPostProductionDashboard(user)) return null;
  const query = new URLSearchParams(search || '');
  const serviceId = Number(query.get('production_service_id'));
  const tab = query.get('production_tab');
  if (!Number.isInteger(serviceId) || serviceId <= 0 || !['processed', 'unprocessed'].includes(tab)) return null;
  const packages = Object.values(project?.packages || {});
  const services = (project?.services || []).filter(service => service.media_types !== 'matterport' && packages.some(pack =>
    pack.service_id === service.id && !(service.title === 'Floor Plans' && pack.cubicasa)));
  const index = services.findIndex(service => service.id === serviceId);
  return index < 0 ? null : {index, serviceId, unprocessed: tab === 'unprocessed'};
};

export const usesCustomerDashboard = (user) => {
  const roles = user?.roles || {};
  return !!(roles.client || roles.broker || roles.sub_broker) &&
    !roles.admin && !roles.post_production && !roles.sales_rep;
};

export const usesPhotographerDashboard = (user) => {
  const roles = user?.roles || {};
  return !!roles.contractor && !roles.admin && !roles.client && !roles.broker &&
    !roles.sub_broker && !roles.post_production && !roles.sales_rep;
};

export const customerMediaTarget = (user, project, search) => {
  if (!usesCustomerDashboard(user)) return null;
  const id = Number(new URLSearchParams(search || '').get('media_service_id'));
  if (!Number.isInteger(id) || id <= 0) return null;
  const index = (project?.services || []).findIndex(service => service.id === id);
  return index < 0 ? null : {index, serviceId: id};
};

export const photographerUploadTarget = (user, project, search) => {
  if (!usesPhotographerDashboard(user)) return null;
  const serviceId = Number(new URLSearchParams(search || '').get('upload_service_id'));
  if (!Number.isInteger(serviceId) || serviceId <= 0) return null;
  const assigned = Object.values(project?.packages || {}).filter(pack => pack.contractor_id === user.id);
  const services = (project?.services || []).filter(service => assigned.some(pack => pack.service_id === service.id));
  const index = services.findIndex(service => service.id === serviceId);
  return index < 0 ? null : {index, serviceId};
};
